export default {
      id: "teaching-usage",
      viewBox: "0 0 57 55",
      url: "/dist/svg/" + "sprite.svg#teaching-usage",
      toString: function () {
        return this.url;
      }
    }